import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context/index.js";
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from "../types.js";
import { ButtonViewer } from "./button-viewer.js";
const Button = ({ node, nodeIndex, NodeViewContainer }) => {
  const { helpers, config, onNodeClick, baseUrl } = useContext(RicosViewerContext);
  const settings = node.buttonData?.type === "ACTION" ? config[ACTION_BUTTON_TYPE] : config[LINK_BUTTON_TYPE];
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { key: node.id, node, nodeIndex }, /* @__PURE__ */ React.createElement(
    ButtonViewer,
    {
      nodeId: node.id,
      helpers,
      settings,
      buttonData: node.buttonData,
      onClick: () => onNodeClick?.({ node }),
      baseUrl
    }
  ));
};
var button_default = Button;
export {
  button_default as default
};
//# sourceMappingURL=button.js.map

import "@wix/ricos/css/plugin-button-viewer.global.css";